import React, { useState, useEffect, useRef } from 'react';
import './index.css';

import { Button, Table, Tooltip, Modal, message } from "antd";
import { PlusOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons';

import Moudle from "./module/index";

import { time } from "../../approach/base";

function Page3(props:any){
    //window.$axios.initRequest.setEnv(null, { "Authorization":"Bearer "+cookie.get("access_token") });
    
    const [ dataList, setDataList ] = useState([]);
    const [ pagination, setPagination ] = useState({
        showQuickJumper: true,
        current: 1,
        pageCount: 10,
        defaultCurrent: 1,
        pageSize: 10,
        defaultPageSize: 10,
        total: 0,
        showTotal: (total:any) => `共${total}条数据`,
    });
    const [ loading, setLoading ] = useState(false);

    const moudleRef:any = useRef();

    const { getBidInfoList } = window.$axios.request;

    useEffect(() => {
        _getData();
    },[pagination.current])

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            // width: "5%"
        },
        {
            title: "标题",
            dataIndex: "mainTitle",
            key: "mainTitle",
            // width: "20%"
        },
        {
            title: "公司名称",
            dataIndex: "companyName",
            key: "companyName",
            // width: "20%"
        },
        {
            title: "开始时间",
            dataIndex: "beginDate",
            key: "beginDate",
            // width: "10%",
            // render: (text:number) => {
            //     return time(text*1000);
            // }
        },
        {
            title: "结束时间",
            dataIndex: "endDate",
            key: "endDate",
            // width: "10%",
            // render: (text:number) => {
            //     return time(text*1000);
            // }
        },
        {
            title: "状态",
            dataIndex: "bidStatus",
            key: "bidStatus",
            // width: "20%",
            render: (text:number) => {
                switch (text) {
                    case -1:
                        return "已废除"
                        break;
                    case 0:
                        return "未开始"
                        break;
                    case 1:
                        return "进行中"
                        break;
                    case 2:
                        return "已结束"
                        break;
                    case 3:
                        return "已失效"
                        break;
                            
                    default:
                        break;
                }
            }
        },
        {
            title: "招标部门",
            dataIndex: "bidType",
            key: "bidType",
            // width: "20%",
            render: (text:number) => {
                switch (text) {
                    case 1:
                        return "采购招标"
                        break;
                    case 2:
                        return "设计招标"
                        break;
                    case 3:
                        return "工程招标"
                        break;
                            
                    default:
                        break;
                }
            }
        },
        {
            title: "正文附件",
            dataIndex: "mainBody",
            key: "mainBody",
            // width: "20%",
            render: (text:string, item:any, index:number) => {
                return <a href={item.mainBody} download="download" target="_blank">预览</a>;
            } 
        },
        {
            title: "操作",
            dataIndex: 'index',
            key: 'index',
            // width: "10%",
            render: (text:string, item:any, index:number) => {
                return (
                    <React.Fragment>
                        <Button
                            type="primary"
                            icon={<FormOutlined />}
                            title="编辑"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                moudleRef.current._Edit(item);
                            }}
                        >
                        </Button>
                        {/* <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                            title="删除"
                            onClick={() => {
                                _delete(item)
                            }}
                        >
                        </Button> */}
                    </React.Fragment>
                );
            }
        }
    ];


    const _setModelVisible = () => {
        moudleRef.current._Add();
    }

    const _delete = (item:any) => {
        Modal.confirm({
            title: '是否确定删除!',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {

            },
            onCancel() {}
        });
    }

    const _getData = () => {
        let param = {};
        param["pageNum"] = pagination.current;
        param["pageSize"] = pagination.pageSize;
        _fetch(param);
    }

    const _fetch = (param:object) => {
        setLoading(true);
        getBidInfoList({},{...param}).then((res:any)=> {
            if(res.code == 1000){
                const newPagination = Object.assign({}, pagination, {
                    total: res.data.total
                });
                setPagination(newPagination);
                setDataList(res.data.list);
                setLoading(false);
            }else{
                message.error(res.msg);
            }
        }).catch((err:any) => {
            message.error(err.msg);
        })
    };

    const _changePage = async(newPagination:any, filters:object, sorter:object) => {
        const page = { ...pagination,...newPagination };
        await setPagination(page);
    }

    const _renderHeader = () => {
        
        return (
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"20px"}}>
                <div>
                    <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        _setModelVisible()
                    }}
                    >新建</Button>
                </div>
                <div>
                </div>
            </div>

        )
    }

    const _renderTab = () => {
        return (
            <Table
                bordered
                locale={{ emptyText: '暂无数据' }}
                rowKey={(record:any) => record.id}
                columns={columns}
                dataSource={dataList}
                pagination={pagination}
                loading={loading}
                onChange={_changePage}
            />
        )
    }

    const _renderPostGodModule = () => {
        return (
            <Moudle
                ref={moudleRef}
                service={window.$axios}
                propsFunc={_getData}
            />
        )
    }


    return (
        <React.Fragment>
            {_renderHeader()}
            {_renderTab()}
            {_renderPostGodModule()}
        </React.Fragment>
    )
}

export default Page3;
